import React from 'react';
import { Dropdown, Avatar } from 'antd';
import { UserOutlined, LogoutOutlined, EditOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import keycloak from '../keycloak/keycloak';

const UserProfileDropdown = () => {
  const navigate = useNavigate();

  const handleMenuClick = ({ key }) => {
    if (key === 'logout') {
      localStorage.removeItem("token");
      keycloak.logout();
    } else {
      navigate(`/${key}`);
    }
  };

  const menuItems = {
    items: [
      { key: 'edit-account', icon: <EditOutlined />, label: 'Edit account' },
      { key: 'user-profile', icon: <UserOutlined />, label: 'User profile' },
      { key: 'logout', icon: <LogoutOutlined />, label: 'Log out' },
    ],
    onClick: handleMenuClick,
  };

  return (
    <Dropdown menu={menuItems} trigger={['click']}>
      <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
        <Avatar icon={<UserOutlined />} style={{ backgroundColor: '#1890ff' }} />
      </div>
    </Dropdown>
  );
};

export default UserProfileDropdown;
